import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvTag";
let LvTag = class LvTag extends UIComponent {
};
__decorate([
    Prop({ type: String, required: false, default: "primary" }),
    __metadata("design:type", String)
], LvTag.prototype, "color", void 0);
LvTag = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvTag);
export default LvTag;
//# sourceMappingURL=script.js.map